import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-companyShow",
  "use": "icon-companyShow-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-companyShow\">\n<image style=\"overflow:visible;\" width=\"48\" height=\"42\" xlink:href=\"\" transform=\"matrix(5.4585 0 0 5.4585 -24.3393 -369.9636)\">\n</image>\n<g>\n\t<path class=\"st0\" d=\"M188.3,134.3H11.7c-3.9,0-7-3.1-7-7v-112c0-3.9,3.1-7,7-7h176.7c3.9,0,7,3.1,7,7v112\n\t\tC195.3,131.1,192.2,134.3,188.3,134.3z M14.7,124.3h170.7v-106H14.7V124.3z\" />\n</g>\n<g>\n\t<polygon class=\"st1\" points=\"171.7,186.9 100,115.3 28.3,186.9 \t\" />\n\t<path class=\"st0\" d=\"M183.7,191.9H16.3l83.7-83.7L183.7,191.9z M40.4,181.9h119.2L100,122.3L40.4,181.9z\" />\n</g>\n<g>\n\t<polygon class=\"st0\" points=\"38.1,97.7 34.7,94.1 86,44.8 127.1,80.9 168.5,46.3 171.7,50.1 127,87.5 86.1,51.6 \t\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/companyShow.svg
// module id = teSp
// module chunks = 183